// extracted by mini-css-extract-plugin
module.exports = {"underline":"UnderlinedText_underline__3sfJ6"};